import { Injectable, Inject, InjectionToken } from "@angular/core";
import {
	HttpEvent,
	HttpInterceptor,
	HttpHandler,
	HttpRequest,
	HttpResponse,
	HttpHeaders,
	HttpErrorResponse,
} from "@angular/common/http";

import { Observable, observable, Subject, throwError } from "rxjs";
import { environment } from "../environments/environment.prod";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material";
import { catchError, map, tap, timeout } from "rxjs/operators";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedService } from "./shared/sharedServices/shared.service";
import { Subject_Service } from "./shared/sharedServices/subject.service";

@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
	constructor(
		private router: Router,
		private dialog: MatDialog,
		private modalService: NgbModal,
		private sharedService: SharedService,
		private subjectService: Subject_Service,
		private dialogRef: MatDialog
	) {}
	redirectToLogin() {
		this.router.navigate(["auth/login"]);
		localStorage.removeItem("esp-profile-details");
		localStorage.clear();
		this.dialogRef.closeAll();
	}
	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		const URL = "/startup-1.0/";
		const requestURL = request.url;
		if (requestURL.includes(URL) && !requestURL.includes("authenticate")) {
			const access_token = localStorage.getItem(
				environment.JWT
			) as string;
			if (access_token) {
				request = request.clone({
					setHeaders: {
						Authorization: `Bearer ${access_token}`,
					},
				});
			}
			return next.handle(request).pipe(
				catchError((err: any) => {
			  
				  if (err instanceof HttpErrorResponse) {
			  
					if (err.status === 401 || err.status === 403) {
					  this.redirectToLogin();
					  this.sharedService.openConditionalErrors(
						"Your session has expired.",
						[
						  "Please login again. Don't worry, we kept all your work saved",
						]
					  );
					}
			  
					else if (err.status === 500) {
					  this.subjectService.appDataLoading.next({
						appDataLoading: false,
					  });
			  
					  this.sharedService.showError(
						"Something went wrong. Please contact support for technical assisstance.",
						"OK",
						"error-snackbar"
					  );
					}
			  
				  }
			  
				  // ✅ Return the actual error object
                   return throwError(err);
				})
			  );
		}

		let headers = new HttpHeaders();
		let payload = JSON.parse(localStorage.getItem("login"));
		if (payload) {
			headers = headers.append(
				"Authorization",
				"Basic " + btoa(payload["username"] + ":" + payload["password"])
			);
			headers = headers.append("X-Requested-With", "XMLHttpRequest");
			let httpOptions = { headers: headers };
			const currentUser = localStorage.getItem("esp-profile-details");
			if (currentUser) {
				request = request.clone({
					// withCredentials: true,
					headers: headers,
					withCredentials: true,
				});
			}
			request = request.clone({
				withCredentials: true,
			});

			return next.handle(request).pipe(
				tap(
					() => {},

					(err: any) => {
						if (err instanceof HttpErrorResponse) {
							if (err.status !== 401) {
								return;
							}
							this.router.navigate(["auth/login"]);
							this.dialog.closeAll();
							this.modalService.dismissAll();
							// this.activeModal.close(false)
							localStorage.removeItem("esp-profile-details");
							localStorage.removeItem("login");
							localStorage.removeItem("ng2Idle.main.expiry");
							localStorage.removeItem("eduHistory");
							localStorage.removeItem("dob");
							localStorage.removeItem("loginDetails");
							localStorage.removeItem("addresses");
							localStorage.removeItem("primaryNationality");
							localStorage.removeItem("name");
							localStorage.removeItem("Avatar");
							localStorage.removeItem("isForeign");
							document.cookie = "profile=; _ga=0; path=/";
							// localStorage.clear()
						}
					}
				)
			);
		} else {
			this.router.navigate(["auth/login"]);
			localStorage.removeItem("esp-profile-details");
			localStorage.clear();
		}
	}
}
